import React, { useState, useEffect, useMemo, Suspense } from "react";
import { Form, Input, Button, Row, Col, DatePicker, message, InputNumber, Table, Tooltip, Tabs, AutoComplete, Modal, Upload, Collapse, Steps } from "antd";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { UploadOutlined, PlusOutlined, DeleteOutlined, MinusOutlined, PlusCircleOutlined, QuestionCircleOutlined, CloseOutlined, TeamOutlined, UserSwitchOutlined, FileDoneOutlined, ArrowLeftOutlined, EyeOutlined } from "@ant-design/icons";
import { API_URL, invoiceFrequencyOptions, natureOptions, } from "../../utils/Constant";
import { useNavigate, Link, useParams } from "react-router-dom";
import { agreementOptions } from "../../utils/Constant";
import ButtonComp from "../../components/button/ButtonComp";
import { convertIntoFormData, ctrlDcmalVal, isEqualCurrency, toTitleCase } from "../../utils/utils";
import MasterTemplateModal from "../masterTemplate/MasterTempModal";
import ClausesModal from "../clauseTemplate/clauseTemplateModal";
import useClipboardAutoFill from "../../utils/clipBorad";
import { getAllISOCodes } from "iso-country-currency";
import { isNumberCheck } from '../../../src/utils/service/formValidation'
import { onChangeCollapsed } from '../../app/slice/globalData.js'
import { useDispatch, useSelector } from "react-redux";
import './css/createRequest.css'
import SingleFileUpload from "../../components/SingleFileUpload";
import axiosInstance from "../../utils/axiosInstance.js";
import { useSearchParams } from "react-router-dom";
import { useTheme } from "../../utils/themeToggle/theme.jsx";

const EditDocComponent = React.lazy(() => import('../../syncFusion/SyncButton'));

const { TabPane } = Tabs;
const { Panel } = Collapse;

const InitiateRequest = () => {
  const navigate = useNavigate();
  const select = useSelector((state) => state.auth.userInfo);
  const user_role = select.role;
  const companyId = select.company_id;
  const currency = select.currency;
  const dispatch = useDispatch();
  const { params } = useParams();
  const [customFields, setCustomFields] = React.useState([]);
  const [countries, setCountries] = useState();
  const [companyName, setCompanyName] = useState();
  const [businessEntity, setBusinessEntity] = useState();
  const [copyConfirmation, setCopyConfirmation] = useState(false);
  const [clientStates, setClientStates] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [templateData, setTemplateData] = useState([]);
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const [clausesData, setClausesData] = useState([]);
  const [masterClausesData, setMasterClausesData] = useState([]);
  const [autofillDoc, setAutofillDoc] = useState(null);
  const [showEditor, setShowEditor] = useState(true);
  const [partyStates, setPartyStates] = useState([]);
  const [partyStatesClicked, setPartyStatesClicked] = useState(false);
  const [products, setProducts] = useState([]);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [fileName, setFilename] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [clientCountry, setClientCountry] = useState(null);
  const [partyCountry, setPartyCountry] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [dateModalVisible, setDateModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [years, setYears] = useState();
  const [months, setMonths] = useState();
  const [days, setDays] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [clausesModal, setClausesModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [selectedClauseData, setSelectedClauseData] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [agreement_id, setAgreement_id] = useState("");
  const [agreemnt_file, setagreemnt_file] = useState("");
  const [hasBeenShown, setHasBeenShown] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchParams] = useSearchParams();
  const urlAgreementId = searchParams.get("agreement_id");
  const compnayId = localStorage.getItem("companyId") || companyId;
  const currentPath = window.location.pathname;
  const { reactSelectTheme } = useTheme();

  console.log("Current Path:", currentPath);

  useEffect(() => {
    if (urlAgreementId) {
      setAgreement_id(urlAgreementId);
    }
  }, [urlAgreementId]);

  const { TextArea } = Input;
  const handleYearsChange = (value) => {
    setYears(value);
  };

  const handleMonthsChange = (value) => {
    setMonths(value);
  };

  const handleDaysChange = (value) => {
    setDays(value);
  };

  const [form] = Form.useForm();
  const { inputValue, handleInputClick, handleInputChanges } =
    useClipboardAutoFill(form);
  const handleAddCustomField = () => {
    setCustomFields([...customFields, { field: "", value: "" }]);
  };

  const handleRemoveCustomField = (index) => {
    const updatedFields = [...customFields];
    updatedFields.splice(index, 1);
    setCustomFields(updatedFields);
  };

  const handleCustomFieldChange = (index, field, value) => {
    const updatedFields = [...customFields];
    updatedFields[index] = { field, value };
    setCustomFields(updatedFields);
  };

  const productOptions = useMemo(() => {
    if (products && Array.isArray(products)) {
      return products.map((item, index) => ({
        value: item.product_name,
        label: toTitleCase(item.product_name),
      }));
    } else {
      return []
    }
  }, [products])

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await axiosInstance.get(`/country/get/`);
        setCountries(response.data);
      } catch {
        console.log('got error')
      }
    };
    fetchCompanyDetails();
    fetchCompanyUsers();
    fetchCountry();
    fetchProduct();
    fetchMasterTemplates();
    fetchTemplates();
    countryCurrency();
  }, []);

  const fetchClientState = async () => {
    try {
      if (clientCountry !== null) {
        const response = await axiosInstance.get("/state/get/", {
          customParams: {
            country_id: clientCountry,
          },
        });
        setClientStates(response.data); // Update the state with the fetched user data
      }
    } catch (error) { }
  };
  const fetchPartyState = async () => {
    try {
      if (partyCountry !== null) {
        const response = await axiosInstance.get("/state/get/", {
          customParams: {
            country_id: partyCountry,
          },
        });
        setPartyStates(response.data); // Update the state with the fetched user data
      }
    } catch (error) { }
  };
  const fetchCompanyDetails = async () => {
    try {
      const response = await axiosInstance.get(`/company/${compnayId}/get/`);
      setCompanyName(response.data.name);
      setBusinessEntity(response.data);
      setPartyCountry(response.data.address.country.id);
      fetchPartyState();
    } catch (error) { }
  };
  const fetchProduct = async () => {
    try {
      const response = await axiosInstance.get(`/company/get_product/?company_id=${compnayId}`);
      setProducts(response.data.data); // Update the state with the fetched user data
    } catch (error) {
      console.error(error)
    }
  };
  const fetchCompanyUsers = async () => {
    try {
      const response = await axiosInstance.post(`/user/get_user_email/`, {
        is_active: true,
        company_id: compnayId,
      }
      );
      const newOptions = response.data.data.map((item) => ({
        value: item.email, // Set the value to the email property
        label: item.first_name,
        role: item.role, // Set the label to a relevant property from your API data
        // Set the label to a relevant property from your API data
      }));
      setCompanyUsers(newOptions);
    } catch (error) { }
  };
  useEffect(() => {
    if (clientCountry !== undefined) {
      fetchClientState();
    }
  }, [clientCountry]);

  useEffect(() => {
    if (partyCountry !== undefined) {
      fetchPartyState();
    }
  }, [partyCountry]);

  const handleClientCountry = (values) => {
    if (values) {
      setClientCountry(values.value);
    } else {
      setClientCountry(null);
    }
  };
  const handlePartyCountry = (values) => {
    if (values) {
      setPartyCountry(values.value);
    } else {
      setPartyCountry(null);
    }
    form.setFieldsValue({
      party_address: {
        state: null
      }
    });

    setPartyStatesClicked(true);
  };
  const handleProductChange = (values) => {
    setSelectedProducts(values);
  };
  const handleReceiversEmailChange = (values) => {
    const selectedValues = Object.values(values).map((item) => item.value);
    setSelectedEmails(selectedValues);
  };

  useEffect(() => {
    const tempRow = [];
    const selectedProductArr = selectedProducts.map((product) =>
      product.label.toLowerCase()
    );
    const dataArr = data.map((row) => row.product_name.toLowerCase());
    data.forEach((row) => {
      if (selectedProductArr.includes(row.product_name.toLowerCase()))
        tempRow.push(row);
    });
    selectedProducts.forEach((prod) => {
      if (!dataArr.includes(prod.label.toLowerCase())) {
        tempRow.push({
          product_name: prod.value,
          invoice_frequency: null,
          credit_term: null,
          invoice_raising_date: null,
          value: null,
          custom_fields: null,
        });
      }
    });
    setData(tempRow);
  }, [selectedProducts]);

  const handleInputChange = (index, columnName, value) => {
    const newData = [...data];
    newData[index][columnName] = value;
    setData(newData);
  };
  const handleAddRow = (index) => {
    const clickedProduct = data[index];
    const newData = [...data];

    const newRow = {
      product_name: clickedProduct.product_name, // Add other properties and set them to initial values
      invoice_frequency: null,
      credit_term: null,
      invoice_raising_date: null,
      value: null,
      custom_fields: null,
    };

    newData.splice(index + 1, 0, newRow);

    setData(newData);
  };
  const handleRemoveRow = (index) => {
    // Remove the row at the specified index
    const updatedData = [...data];
    updatedData.splice(index, 1);
    setData([...updatedData]);
  };
  const countryCurrency = async () => {
    try {
      const codes = await getAllISOCodes();
      const transformedData = codes.map((code) => ({
        value: `${code.symbol}+${code.countryName}`,
        label: `${code.countryName} (${code.symbol})`,
      }));
      setCurrencyOptions(transformedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const columns = [
    {
      title: "Products / Services",
      // dataIndex: "product",
      ellipsis: true,
      width: 110,
      render: (_, record, index) => (
        <>
          <h1 className="text-[12px]">{record.product_name}</h1>
        </>
      ),
    },
    {
      title: (
        <>
          Invoice Frequency{" "}
          <Tooltip title="One Time/ Monthly/ Quarterly/ Half Yearly  ">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "invoice_frequency",
      ellipsis: true,
      width: 120,
      render: (_, record, index) => (
        <Select
          key={`record-${record.invoice_frequency || index}`}
          styles={reactSelectTheme}
          size="small"
          className="w-full custom-select-border text-[12px]"
          menuPortalTarget={document.body}
          defaultValue={() =>
            record.invoice_frequency &&
            invoiceFrequencyOptions.find(
              (option) =>
                option.value.toLowerCase() ===
                record.invoice_frequency.toLowerCase()
            )
          }
          // isClearable
          options={invoiceFrequencyOptions}
          onChange={(selectedOption) =>
            handleInputChange(index, "invoice_frequency", selectedOption.value)
          }
        />
      ),
    },
    {
      title: (
        <>
          Invoice Raising Date{" "}
          <Tooltip title="7th of every succeeding month/ 7th of every month.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "invoice_raising_date",
      ellipsis: true,
      width: 125,
      render: (_, record, index) => (
        <Input
          value={record.invoice_raising_date}
          className="text-[12px] h-[37px]"
          onChange={(e) =>
            handleInputChange(index, "invoice_raising_date", e.target.value)
          }
        />
      ),
    },
    {
      title: (
        <>
          Credit Term{" "}
          <Tooltip title="Maximum Credit Period Allowed">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "credit_term",
      ellipsis: true,
      width: 80,
      render: (_, record, index) => (
        <Input
          value={record.credit_term}
          className="text-[12px] h-[37px]"
          onChange={(e) =>
            handleInputChange(index, "credit_term", e.target.value)
          }
        />
      ),
    },


    {
      title: (
        <>
          Contract Currency{" "}
          <Tooltip title="Select the currency of contract.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency",
      ellipsis: true,
      width: 210,
      render: (_, record, index) => (

        <div key={record?.contract_currency?.toLowerCase()} className="w-52">
          <Select
            styles={reactSelectTheme}
            className="w-full custom-select-border dark:text-gray-200 text-[12px]"
            menuPortalTarget={document.body}
            defaultValue={() => (
              record?.contract_currency &&
              currencyOptions.find(
                (option) =>
                  option.value.toLowerCase() ===
                  record?.contract_currency?.toLowerCase()
              ))
            }
            options={currencyOptions}
            onChange={(selectedOption) => {
              // Handle logic for selected option
              if (isEqualCurrency(selectedOption?.value)) {
                console.log("Equal Currency", selectedOption?.value);
                handleInputChange(index, "value", record.contract_currency_value);
                handleInputChange(index, "conversion_rate", null);
              }
              handleInputChange(index, "contract_currency", selectedOption.value);
            }}
          />
        </div>
      ),
    },
    {
      title: (
        <>
          Contract Currency Value {" "}
          <Tooltip title="Converted currency value.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "contract_currency_value",
      ellipsis: true,
      width: 150,
      render: (_, record, index) => (
        <Input
          value={record.contract_currency_value || ''}
          className="disabled:bg-transparent text-[12px] h-[37px]"
          onChange={(e) => {
            const inputValue = e.target.value;
            if (isNumberCheck(inputValue)) {
              let contract_currency_value;
              if (isEqualCurrency(record?.contract_currency) || !record?.conversion_rate) {
                contract_currency_value = inputValue;
              } else {
                contract_currency_value = record.conversion_rate * inputValue;
              }
              handleInputChange(index, "contract_currency_value", inputValue);
              handleInputChange(index, "value", contract_currency_value);
              if (!inputValue) {
                handleInputChange(index, "conversion_rate", null);
              }
              return;
            }
            message.error("Please enter only numerical value.");
          }
          }
        />
      ),
    },

    {
      title: (
        <>
          Conversion Rate{" "}
          <Tooltip title="Enter conversion rate from base currency to contract currency.">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "conversion_rate",
      ellipsis: true,
      width: 110,
      render: (_, record, index) => (
        <Input
          disabled={
            !record.contract_currency_value
            || isEqualCurrency(record.contract_currency)
          }
          className="text-[12px] h-[37px]"
          value={record.conversion_rate || ''}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (isNumberCheck(inputValue)) {
              let contract_currency_value;
              if (!record.contract_currency_value && inputValue) {
                contract_currency_value = inputValue;
              } else if (record.contract_currency_value && !inputValue) {
                contract_currency_value = record.contract_currency_value;
              } else {
                contract_currency_value = record.contract_currency_value * inputValue;
              }
              // Update conversion_rate and value fields
              handleInputChange(index, "conversion_rate", inputValue); // Keep original inputValue for precision
              handleInputChange(index, "value", contract_currency_value);
              return;
            }
            message.error("Please enter only numerical value.");
          }}
        />
      ),
    },


    {
      title: (
        <>
          Base Currency Value{" "}
          <Tooltip title="Total Contract Value">
            <QuestionCircleOutlined />
          </Tooltip>
        </>
      ),
      dataIndex: "value",
      ellipsis: true,
      width: 233,
      render: (_, record, index) => {
        return (
          <Input
            disabled
            value={ctrlDcmalVal(record.value)}
            prefix={<span className="text-[10px]">{currency}</span>} // Display "India (₹)" as prefix
            className="disabled:bg-transparent text-black dark:text-gray-200"
          />
        );
      },
    }
    ,
    {
      title: "Action",
      key: "action",
      ellipsis: true,
      width: 80,
      render: (_, record, index) => (
        <>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => handleAddRow(index)}
            style={{ marginRight: 8 }}
          />
          {data.filter((item) => item.product_name === record.product_name).length > 1 && (
            <Button
              type="danger"
              icon={<MinusOutlined />}
              onClick={() => handleRemoveRow(index)}
            />
          )}
        </>
      ),
    },
  ]
  const stepItems = [
    {
      key: "1",
      title: "Business Partner Information",
      icon: TeamOutlined,
      content: (
        <Row gutter={24}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Business Partner Name"
              name="name_of_client"
              rules={[
                {
                  required: true,
                  message: "Please enter the Business Partner Name",
                },
              ]}
            >
              <Input
                required
                value={inputValue["name_of_client"] || ""} // Use value instead of defaultValue
                onClick={() => handleInputClick(["name_of_client"])}
                onChange={(e) =>
                  handleInputChanges(e, ["name_of_client"])
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Authorised Signatory's Name of Business Partner"
              name="name_of_authorised_signatory_of_party"
            >
              <Input
                required
                value={
                  inputValue[
                  "name_of_authorised_signatory_of_party"
                  ] || ""
                } // Use value instead of defaultValue
                onClick={() =>
                  handleInputClick([
                    "name_of_authorised_signatory_of_party",
                  ])
                }
                onChange={(e) =>
                  handleInputChanges(e, [
                    "name_of_authorised_signatory_of_party",
                  ])
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Address 1"
              name={["client_address", "address1"]}
            >
              <Input
                className="custom-placeholder"
                value={
                  inputValue["client_address"]?.["address1"] || ""
                }
                onClick={() =>
                  handleInputClick(["client_address", "address1"])
                }
                onChange={(e) =>
                  handleInputChanges(e, [
                    "client_address",
                    "address1",
                  ])
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Address 2"
              name={["client_address", "address2"]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Postal Code"
              name={["client_address", "postal_code"]}
            >
              <Input
                maxLength={6}
                onKeyPress={(event) => {
                  const isValidInput = /^[0-9\b]+$/.test(event.key);
                  if (!isValidInput) {
                    event.preventDefault();
                  }
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }} label="City" name={["client_address", "city"]}>
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Country"
              name={["client_address", "country"]}
            >
              <Select
                options={
                  countries &&
                  countries.map((country) => ({
                    value: country.id,
                    label: country.name,
                  }))
                }
                onChange={(e) => {
                  form.setFieldsValue({
                    client_address: {
                      state: null // or an empty string "", or whatever is appropriate
                    }
                  });
                  handleClientCountry(e)
                }}
                isSearchable
                menuPlacement="top" // Set menuPlacement to "top"
                isClearable
                styles={reactSelectTheme}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="State"
              name={["client_address", "state"]}
            >
              <Select
                disabled={!clientCountry}
                options={
                  clientStates && clientStates.length > 0
                    ? clientStates.map((state) => ({
                      value: state.id,
                      label: state.name,
                    }))
                    : [] // default empty array
                }
                menuPlacement="top"
                isClearable
                styles={reactSelectTheme}
              />

            </Form.Item>
          </Col>
        </Row>
      ),
    },
    {
      key: "2",
      title: "Business Entity Information",
      icon: UserSwitchOutlined,
      content: (
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }} label="Business Entity Name" name="party">
              <Input
                required
                defaultValue={companyName || ""}
                value={inputValue["party"] || ""} // Use value instead of defaultValue
                onClick={() => handleInputClick(["party"])}
                onChange={(e) => handleInputChanges(e, ["party"])}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Authorised Signatory's Name of Business Entity"
              name="name_of_authorised_signatory_of_client"
            >
              <Input
                value={
                  inputValue[
                  "name_of_authorised_signatory_of_client"
                  ] || ""
                } // Use value instead of defaultValue
                onClick={() =>
                  handleInputClick([
                    "name_of_authorised_signatory_of_client",
                  ])
                }
                onChange={(e) =>
                  handleInputChanges(e, [
                    "name_of_authorised_signatory_of_client",
                  ])
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Address 1"
              name={["party_address", "address1"]}
              initialValue={businessEntity?.address?.address1 || ""}
            >
              <Input
                // required
                defaultValue={
                  businessEntity &&
                    businessEntity.address &&
                    businessEntity.address.address1
                    ? businessEntity.address.address1
                    : ""
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Address 2"
              name={["party_address", "address2"]}
              initialValue={businessEntity?.address?.address2 || ""}
            >
              <Input
                // required
                defaultValue={
                  businessEntity &&
                    businessEntity.address &&
                    businessEntity.address.address2
                    ? businessEntity.address.address2
                    : ""
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Postal Code"
              name={["party_address", "postal_code"]}
              initialValue={
                businessEntity?.address?.postal_code || ""
              }
            >
              <Input
                // required
                maxLength={6}
                onKeyPress={(event) => {
                  const isValidInput = /^[0-9\b]+$/.test(event.key);
                  if (!isValidInput) {
                    event.preventDefault();
                  }
                }}
                defaultValue={
                  businessEntity &&
                    businessEntity.address &&
                    businessEntity.address.postal_code
                    ? businessEntity.address.postal_code
                    : ""
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="City"
              name={["party_address", "city"]}
              initialValue={businessEntity?.address?.city || ""}
            >
              <Input
                // required
                defaultValue={
                  businessEntity &&
                    businessEntity.address &&
                    businessEntity.address.city
                    ? businessEntity.address.city
                    : ""
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="Country"
              name={["party_address", "country"]}
            >
              <Select
                options={
                  countries &&
                  countries.map((country) => ({
                    value: country.id,
                    label: country.name,
                  }))
                }
                onChange={handlePartyCountry}
                // required
                defaultValue={
                  businessEntity &&
                  businessEntity.address &&
                  businessEntity.address.country && {
                    value: businessEntity.address.country.id,
                    label: businessEntity.address.country.name,
                  }
                }
                menuPlacement="top" // Set menuPlacement to "top"
                isClearable
                styles={reactSelectTheme}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Form.Item style={{ borderRadius: 6 }}
              label="State"
              name={["party_address", "state"]}
            >
              <Select
                disabled={partyCountry}
                options={
                  partyStates.length > 0 &&
                  partyStates.map((state) => ({
                    value: state.id,
                    label: state.name,
                  }))
                }
                // required
                defaultValue={
                  businessEntity &&
                  businessEntity.address &&
                  businessEntity.address.state && {
                    value: businessEntity.address.state.id,
                    label: businessEntity.address.state.name,
                  }
                }
                menuPlacement="top" // Set menuPlacement to "top"
                isClearable
                styles={reactSelectTheme}
              />
            </Form.Item>
          </Col>
        </Row>
      ),
    },
    {
      key: "3",
      title: "Agreement Details",
      icon: FileDoneOutlined,
      content: (
        <>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }}
                label="Agreement"
                name="agreement_type"
                rules={[
                  {
                    required: true,
                    message: "Please Select Ageement Type",
                  },
                ]}
              >
                <AutoComplete
                  options={agreementOptions.map((option) => ({
                    value: option.value,
                  }))}
                  filterOption={(inputValue, option) =>
                    option.value
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  placeholder="Select or type to add agreement"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }}
                label="Nature"
                name="nature"
                rules={[
                  {
                    required: true,
                    message: "Please Select Nature",
                  },
                ]}
              >
                <AutoComplete
                  options={natureOptions.map((option) => ({
                    value: option.value,
                  }))}
                  filterOption={(inputValue, option) =>
                    option.value
                      .toUpperCase()
                      .indexOf(inputValue.toUpperCase()) !== -1
                  }
                  placeholder="Select or type to add nature"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }}
                label="Termination Notice"
                name="termination_notice"
              >
                <Input
                  className="custom-placeholder"
                  value={inputValue["termination_notice"] || ""} // Use value instead of defaultValue
                  onClick={() =>
                    handleInputClick(["termination_notice"])
                  }
                  onChange={(e) =>
                    handleInputChanges(e, ["termination_notice"])
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }} label="Jurisdiction" name="jurisdiction">
                <Input
                  value={inputValue["jurisdiction"] || ""} // Use value instead of defaultValue
                  onClick={() => handleInputClick(["jurisdiction"])}
                  onChange={(e) =>
                    handleInputChanges(e, ["jurisdiction"])
                  }
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }} label="Effective Date" name="effective_date">
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }} label="Execution Date" name="execution_date">
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  // required
                  disabledDate={() => false}
                  onChange={(date, dateString) => {
                    const selectedDate = new Date(date);
                    const today = new Date();
                    if (selectedDate > today) {
                      setDateModalVisible(true);
                    }
                  }}
                />
              </Form.Item>
              <Modal
                title="Warning"
                open={dateModalVisible}
                onOk={() => setDateModalVisible(false)}
                onCancel={() => setDateModalVisible(false)}
                okText="Yes"
                cancelText="No"
              >
                You have selected a future date as Execution Date. Press
                ‘Yes’ if you intend to proceed with the selected future
                date.
              </Modal>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }} label="Status" name="status">
                <Input disabled defaultValue="Fresh Request" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Form.Item style={{ borderRadius: 6 }} label="Tenure" name="tenure">
                <div className='w-full flex justify-start items-center gap-[10px]'>
                  <InputNumber
                    min={0}
                    value={years}
                    onChange={handleYearsChange}
                    placeholder="Years"
                  />
                  <InputNumber
                    min={0}
                    value={months}
                    onChange={handleMonthsChange}
                    placeholder="Months"
                  />
                  <InputNumber
                    min={0}
                    value={days}
                    onChange={handleDaysChange}
                    placeholder="Days"
                  />
                </div>
              </Form.Item>
            </Col>
          </Row>
          {/* <Modal
            title=""
            open={copyConfirmation}
            onOk={() => getAutofillDoc(false)}
            onCancel={() => setCopyConfirmation(false)}
            okText={isLoading ? "Uploading.." : "Yes"}
            cancelText="No"
            okButtonProps={{ disabled: isLoading }}
          >
            You have selected a document as agreement file. Press ‘Yes’ if
            you intend to proceed with the autofill.
          </Modal> */}
        </>
      ),
    },

  ];
  const options = [
    { value: "local", label: "From Device" },
    { value: "masterTemplate", label: "Master Template" },
    { value: "clauses", label: "Clauses" },
  ];

  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const getFieldsToValidate = () => {
    switch (activeTab) {
      case "1":
        return [
          "name_of_client",
          "party",
          "agreement_type",
          "nature",
        ];
      case "4":
        return ["product_list"];
      default:
        return ["receivers_email"];
    }
  };
  const handleNext = async () => {
    try {
      // await form.validateFields();
      const fieldsToValidate = getFieldsToValidate(); // Implement this function
      await form.validateFields(fieldsToValidate);

      const nextTab = (parseInt(activeTab, 10) % 4) + 1;
      setActiveTab(nextTab.toString());
    } catch (errorInfo) {
      const firstErrorField = errorInfo?.errorFields?.[0];
      const msg = firstErrorField?.errors?.[0] || 'Form validation failed';
      message.error(msg);
    }
  };
  const getTabIndexForField = (fieldName) => {
    switch (fieldName[0]) {
      case "name_of_client":
      case "name_of_authorised_signatory_of_party":
      case "client_address.address1":
      case "client_address.address2":
      case "client_address.city":
      case "client_address.postal_code":
      case "client_address.country":
      case "client_address.state":
      case "party":
      case "name_of_authorised_signatory_of_client":
      case "party_address.address1":
      case "party_address.address2":
      case "party_address.city":
      case "party_address.postal_code":
      case "party_address.country":
      case "party_address.state":
      case "agreement_type":
      case "nature":
      case "termination_notice":
      case "jurisdiction":
      case "effective_date":
      case "execution_date":
      case "status":
      case "remarks":
      case "tenure":
      case "agreement_file":
        return "1";
      case "product_list":
        return "4";
      case "custom_fields":
        return "5";
      case "receivers_email":
        return "6";
      default:
        return "1"; // Default to the first tab
    }
  };
  const handlePrevious = () => {
    const previousTab = ((parseInt(activeTab, 10) - 2 + 4) % 4) + 1;
    setActiveTab(previousTab.toString());
  };

  const fetchTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/create_template/?company_id=${compnayId}`);
      setIsLoading(false);
      setTemplateData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const fetchMasterTemplates = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-template/`);
      setIsLoading(false);
      setMasterTemplateData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const ftechClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/clause/?company_id=${compnayId}`);
      setIsLoading(false);
      setClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const fetchMasterClauses = async () => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.get(`/contract/get-master-clause/`);
      setIsLoading(false);
      setMasterClausesData(response.data);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getAutofillDoc = async () => {
    try {
      setIsLoading(true);
      const payload = convertIntoFormData({ file: fileName });
      const response = await axiosInstance.post(`/contract/upload_for_autofill/`, payload);
      setIsLoading(false);
      setCopyConfirmation(false);
      setAutofillDoc(response.data.Fileurl);
      setagreemnt_file(response.data.Fileurl);
      dispatch(onChangeCollapsed(true))
      // setautofillDoc(true)
    } catch (error) {
      setIsLoading(false);
      setCopyConfirmation(false);
    }
  };
  const getAutofillDoccc = async (fileUrlParam) => {
    try {
      setIsLoading(true);
      const payload = convertIntoFormData({ file: fileUrlParam });
      const response = await axiosInstance.post(`/contract/upload_for_autofill/`, payload);
      setIsLoading(false);
      setCopyConfirmation(false);
      setAutofillDoc(response.data.Fileurl);
      dispatch(onChangeCollapsed(true))
    } catch (error) {
      setIsLoading(false);
      setCopyConfirmation(false);
    }
  };
  const handleOptionChange = (value) => {
    setSelectedOption(value);
    setFilename('');
    setAutofillDoc(false);
    setagreemnt_file("");
    // Show the modal when "Master Template" is selected
    if (value?.value === "masterTemplate") {
      setModalVisible(true);
    } else if (value?.value === "clauses") {
      setClausesModal(true);
      ftechClauses();
      fetchMasterClauses();
    } else {
      setSelectedTemplate([]);
      setSelectedClauseData([]);
    }
  };
  const handleModalCancel = () => {
    setModalVisible(false);
    setClausesModal(false);
  };
  const handleTemplateSelect = (data) => {
    setSelectedTemplate(data);
  };
  const handleSequenceChange = (id, sequence) => {
    setClausesData(
      clausesData.map((item) => {
        if (item.id === id) {
          return { ...item, sequence };
        }
        return item;
      })
    );
  };
  const handleRowClick = (record) => { };
  const handleClauseSubmit = (data) => {
    setSelectedClauseData(data);
  };


  const onChnageFile = (fileValue) => {
    if (fileValue?.originFileObj) {
      setFilename(fileValue.originFileObj);
      setAutofillDoc(false);
      setagreemnt_file(""); // reset preview
      setCopyConfirmation(true);
    } else {
      setFilename("");
      setAutofillDoc(false);
      setagreemnt_file("");
    }
  };

  const iconStyle = (active) => ({
    fontSize: 20,
    color: active ? "#fff" : "#1890ff",
    backgroundColor: active ? "#1890ff" : "#f0f0f0",
    borderRadius: "50%",
    padding: 6,
    border: `1px solid ${active ? "#1890ff" : "#d9d9d9"}`,
    transition: "all 0.3s ease",
  });
  const handleCollapseChange = (keys) => {
    setOpenKeys(keys);
  };
  const handleDocSave = async (blob) => {
    setHasBeenShown(true); // start loader

    const file = new File([blob], "updated_agreement.docx", { type: blob.type });
    const formData = new FormData();
    formData.append("agreement_id", agreement_id);
    formData.append("agreement_file", file);
    formData.append("company_id", compnayId);

    try {
      const response = await axiosInstance.post(`/contract/save_agreement_file/`, formData);
      setagreemnt_file(response?.data?.agreement_file)
      message.success(response?.data?.message || "Document saved successfully");

    } catch (error) {
      message.error(error?.response?.data?.message || "Failed to save document");
    }

    setHasBeenShown(false); // stop loader
  };
  const handleSubmit = async () => {
    console.log("handleSubmit called", agreement_id);
    if (agreement_id) {
      handleContractUpdate(false)
      return;
    }
    try {
      setIsLoading(true);
      await form.validateFields();
      const values = await form.getFieldsValue();
      const customFieldValues = customFields.reduce((acc, field, index) => {
        const fieldKey = `field${index + 1}`;
        const valueKey = `value${index + 1}`;
        return { ...acc, [fieldKey]: field.field, [valueKey]: field.value };
      }, {});
      const effectiveDate =
        values.effective_date &&
        values.effective_date.format("YYYY-MM-DDTHH:mm:ss");
      const executionDate =
        values.execution_date &&
        values.execution_date.format("YYYY-MM-DDTHH:mm:ss");
      const paymentDueDate =
        values.payment_due_date &&
        values.payment_due_date.format("YYYY-MM-DDTHH:mm:ss");

      const country =
        values.client_address && values.client_address.country
          ? values.client_address.country.value
          : "";
      const state =
        values.client_address && values.client_address.state
          ? values.client_address.state.value
          : "";

      const party_country =
        values.party_address && values.party_address.country
          ? values.client_address.country.value
          : businessEntity &&
            businessEntity.address &&
            businessEntity.address.country
            ? businessEntity.address.country.id
            : "";
      const party_state =
        values.party_address && values.party_address.state
          ? values.party_address.state.value
          : businessEntity &&
            businessEntity.address &&
            businessEntity.address.state
            ? businessEntity.address.state.id
            : "";
      const partyFieldValue = form.getFieldValue("party");

      let formData = {
        ...values,
        custom_field: JSON.stringify(customFieldValues),
        effective_date: effectiveDate,
        execution_date: executionDate,
        payment_due_date: paymentDueDate,
        company_id: compnayId,

        party_address: JSON.stringify({
          ...(values.party_address || {}),
          country: party_country,
          state: party_state,
        }),
        party: partyFieldValue || companyName || "",
        agreement_file: fileName && fileName,
        tenure: `${years ? years : 0} Years ${months ? months : 0} Months ${days ? days : 0
          } Days`,
        product_list: JSON.stringify(data || {}),
      };
      formData.status = "FRESH_REQUEST";

      if (
        true
      ) {
        formData.client_address = JSON.stringify({
          ...(values.client_address || {}),
          ...(country && { country }),
          ...(state && { state }),
          ...(values.client_address?.address1 && {
            address1: values.client_address.address1,
          }),
          ...(values.client_address?.address2 && {
            address2: values.client_address.address2,
          }),
          ...(values.client_address?.city && {
            city: values.client_address.city,
          }),
          ...(values.client_address?.postal_code && {
            postal_code: values.client_address.postal_code,
          }),
        });
      }

      if (
        party_country ||
        party_state ||
        values.party_address?.address1 ||
        values.party_address?.address2 ||
        values.party_address?.city ||
        values.party_address?.postal_code
      ) {
        formData.party_address = JSON.stringify({
          ...(values.party_address || {}),
          ...(party_country && { country: party_country }),
          ...(party_state && { state: party_state }),
          ...(values.party_address?.address1 && {
            address1: values.party_address.address1,
          }),
          ...(values.party_address?.address2 && {
            address2: values.party_address.address2,
          }),
          ...(values.party_address?.city && {
            city: values.party_address.city,
          }),
          ...(values.party_address?.postal_code && {
            postal_code: values.party_address.postal_code,
          }),
        });
      }
      formData.party_address = JSON.parse(formData.party_address);
      Object.keys(formData.party_address).forEach(
        (key) =>
          formData.party_address[key] === "" &&
          delete formData.party_address[key]
      );
      formData.party_address = JSON.stringify(formData.party_address);

      if (selectedEmails && selectedEmails.length > 0) {
        formData.receiver_email = selectedEmails.toString();
      }
      if (selectedTemplate && selectedOption?.value === "masterTemplate") {
        formData.master_template_id = selectedTemplate.id;
      }
      if (selectedClauseData.length > 0 && selectedOption?.value === "clauses") {
        formData.clause_list = JSON.stringify(selectedClauseData);
      }
      formData = convertIntoFormData(formData)
      axiosInstance.post(`/contract/create/`, formData)
        .then((response) => {
          if (response?.data) {
            setAgreement_id(response.data.agreement_id);
            const fileUrl = response.data.agreement_file_url;
            setagreemnt_file(fileUrl);
            setShowEditor(true);
            getAutofillDoccc(fileUrl);
            navigate(`${currentPath}?agreement_id=${response.data.agreement_id}`, { replace: true });

          } else {
            console.error("response.data is missing!", response);
            message.error("Something went wrong with the contract creation.");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          message.error(error?.response?.data?.error);
        });
    } catch (errorInfo) {
      setIsLoading(false);
      const errorMsg = "please check all the mandatory fields.";
      message.error(errorMsg);
    }
  };
  const handleContractUpdate = async (shouldNavigate = true) => {
    try {
      setIsLoading(true);
      await form.validateFields();
      const values = await form.getFieldsValue();

      const customFieldValues = customFields.reduce((acc, field, index) => {
        acc[`field${index + 1}`] = field.field;
        acc[`value${index + 1}`] = field.value;
        return acc;
      }, {});

      const agreementType = values.agreement_type || null;
      const nature = values.nature || null;
      const termination_notice = values.termination_notice || null;
      const party = form.getFieldValue("party") || companyName || null;

      const client_address = {
        id: businessEntity?.client_address?.id || null,
        address1: values.client_address?.address1 || null,
        address2: values.client_address?.address2 || null,
        postal_code: values.client_address?.postal_code || null,
        city: values.client_address?.city || null,
        state: values.client_address?.state?.value || {},
        country: values.client_address?.country?.value || {},
      };

      const party_address = {
        id: businessEntity?.party_address?.id || null,
        address1: values.party_address?.address1 || null,
        address2: values.party_address?.address2 || null,
        postal_code: values.party_address?.postal_code || null,
        city: values.party_address?.city || null,
        state: values.party_address?.state?.value || {},
        country: values.party_address?.country?.value || {},
      };

      const payload = {
        agreement_type: agreementType,
        nature,
        party,
        termination_notice,
        name_of_client: values.name_of_client || null,
        name_of_authorised_signatory_of_party: values.name_of_authorised_signatory_of_party || null,
        tenure: `${years || 0} Years ${months || 0} Months ${days || 0} Days`,
        client_address,
        // agreement_file: agreemnt_file || null,
        party_address,
        product_list: data || [],
        custom_field: customFieldValues,
      };
      if (values.execution_date) {
        payload.execution_date = values.execution_date.format("YYYY-MM-DDTHH:mm:ss");
      }
      if (values.effective_date) {
        payload.effective_date = values.effective_date.format("YYYY-MM-DDTHH:mm:ss");
      }
      if (values.payment_due_date) {
        payload.payment_due_date = values.payment_due_date.format("YYYY-MM-DDTHH:mm:ss");
      }
      if (values.jurisdiction) {
        payload.jurisdiction = values.jurisdiction;
      }

      // step 0: after successful PATCH update
      if (selectedOption?.value === "local" && fileName) {
        const formData = new FormData();
        formData.append("agreement_id", agreement_id);
        formData.append("company_id", compnayId);
        formData.append("agreement_file", fileName);

        const res = await axiosInstance.post(`/contract/save_agreement_file/`, formData);
        setagreemnt_file(res.data.agreement_file);
        setShowEditor(true);
      }

      if (selectedOption?.value === "masterTemplate" && selectedTemplate?.id) {
        const formData = new FormData();
        formData.append("agreement_id", agreement_id);
        formData.append("company_id", compnayId);
        formData.append("master_template_id", selectedTemplate.id);

        const res = await axiosInstance.post(`/contract/save_agreement_file/`, formData);
        setagreemnt_file(res.data.agreement_file);
        setShowEditor(true);
      }

      if (selectedOption?.value === "clauses" && selectedClauseData.length > 0) {
        const formData = new FormData();
        formData.append("agreement_id", agreement_id);
        formData.append("company_id", compnayId);
        formData.append("clause_list", JSON.stringify(selectedClauseData));

        const res = await axiosInstance.post(`/contract/save_agreement_file/`, formData);
        setagreemnt_file(res.data.agreement_file);
        setShowEditor(true);
      }
      if (selectedEmails && selectedEmails.length > 0) {
        await axiosInstance.put(`/contract/${agreement_id}/assign/`, {
          user_email: selectedEmails,
          assign: true,
          company_id: compnayId,
        }).then((response) => {
          message.success(response.data.message);
        }).catch((error) => {
          throw new Error(error.response?.data?.error || "Failed to assign email");
        });
      }

      // ✅ STEP 2: Update Contract
      await axiosInstance.patch(`/contract/${agreement_id}/update/`, { data: payload })
        .then((response) => {
          message.success("Request updated successfully.");
          setIsLoading(false);
          if (shouldNavigate) navigate("/admin/contracts");
        })
        .catch((error) => {
          setIsLoading(false);
          message.error(error.response?.data?.error || "Error in contract update");
        });

    } catch (errorInfo) {
      setIsLoading(false);
      const firstError = errorInfo?.errorFields?.[0];
      const errorMsg = firstError?.errors?.[0] || errorInfo.message || "Please check all the mandatory fields.";
      const tabIndex = getTabIndexForField(firstError?.name);
      message.error(errorMsg);
      setActiveTab(tabIndex);
    }
  };

  console.log(user_role, agreemnt_file, showEditor, autofillDoc)

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        height: "84vh",
        position: "relative",
      }}
    >
      <div className="p-3 flex items-center gap-4">
        <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
          < ArrowLeftOutlined size="20px" className="text-xl transform hover:scale-110 transition-transform duration-300 dark:text-white" />
        </span>
        <h1 className="font-semibold text-[15px] dark:text-white">
          Create New Contract Request
        </h1>
      </div>
      <div className="grow agreement-form">

        <Form
          form={form}
          layout="vertical"
          encType="multipart/form-data"
          className="autofill"
        >
          <Row>
            <Col span={agreemnt_file && showEditor ? 9 : 24}>
              <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
                type="card"
              >
                <TabPane tab="Agreement Info" key="1">
                  <div style={{ paddingTop: 16 }}>

                    {stepItems.map((step, index) => {
                      const isOpen = openKeys.includes(step.key);
                      const Icon = step.icon;

                      return (
                        <Row key={step.key} align="top" style={{ marginBottom: 24 }}>
                          <Col flex="32px">
                            <div
                              onClick={() => {
                                const isAlreadyOpen = openKeys.includes(step.key);
                                setOpenKeys(isAlreadyOpen ? [] : [step.key]);
                              }}
                              style={{ cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5px" }}
                            >
                              <Icon style={iconStyle(isOpen)} />
                            </div>
                          </Col>
                          <Col flex="1" style={{
                            paddingLeft: 16,
                            transition: "width 0.5s ease",
                            width: isOpen ? "100%" : "50%",
                          }}>
                            <Collapse
                              activeKey={openKeys}
                              onChange={handleCollapseChange}
                              expandIconPosition="right"
                              bordered

                            >
                              <Panel header={step.title} key={step.key}>
                                <div style={{
                                  width: isOpen ? "100%" : "50%",
                                  overflow: "hidden",
                                  transition: "width 0.5s ease, opacity 0.3s ease",
                                  opacity: isOpen ? 1 : 0,
                                }}
                                >
                                  {step.content}
                                </div>
                              </Panel>
                            </Collapse>
                          </Col>
                        </Row>
                      );
                    })}
                    <div className="flex relative pb-4">
                      <div className="w-[33px] h-[33px] flex justify-center items-center text-[20px] text-[#1890ff] bg-[#f0f0f0] rounded-full p-[6px] border border-[#d9d9d9] transition-all duration-300 ease-in-out mr-4"  >
                        <UploadOutlined />
                      </div>
                      {agreemnt_file && !showEditor && (
                        <div
                          onClick={() => setShowEditor(true)}
                          className="absolute top-[40px] left-[22px] text-gray-400 cursor-pointer hover:text-gray-500 transition-all text-[18px]"
                        >
                          <EyeOutlined />
                        </div>
                      )}
                      {user_role === "agreement controller head" || user_role === "professional agreement controller team" || user_role === "professional agreement controller head" || user_role === "agreement controller team" || user_role === "professional" ? (
                        <Col span={4} className="mb-6 ">
                          <h1 className="mb-2">Agreement</h1>

                          <Select
                            options={options}
                            value={selectedOption}
                            onChange={handleOptionChange}
                            placeholder="Select Agreement"
                            isClearable
                            styles={reactSelectTheme}
                          />
                          {selectedOption && selectedOption.value === "local" ? (
                            <>
                              <Form.Item style={{ borderRadius: 6 }}
                                label=""
                                name="agreement_file"
                                valuePropName="fileList"
                                getValueFromEvent={(e) => e.fileList}
                                className="mt-2"
                              >
                                <div className="relative w-full">
                                  <SingleFileUpload title='Select File' onChnageFile={onChnageFile} accept='.doc,.docx' />
                                </div>
                              </Form.Item>
                            </>

                          ) : selectedOption &&
                            selectedOption.value === "masterTemplate" ? (
                            <>
                              <MasterTemplateModal
                                visible={modalVisible}
                                onCancel={handleModalCancel}
                                onSelect={handleTemplateSelect}
                                data={templateData}
                                masterTempData={masterTemplateData}
                              />
                              {selectedTemplate && (
                                <div>
                                  <br />
                                  Template Name:{" "}
                                  <br />
                                  <span
                                    className={`bg-blue-500 text-white px-2 py-1 rounded w-full`}
                                  >
                                    {selectedTemplate.template_name}
                                  </span>
                                </div>
                              )}
                            </>
                          ) : selectedOption &&
                            selectedOption.value === "clauses" ? (
                            <ClausesModal
                              visible={clausesModal}
                              onCancel={handleModalCancel}
                              clausesData={clausesData}
                              masterClausesData={masterClausesData}
                              handleSequenceChange={handleSequenceChange}
                              handleRowClick={handleRowClick}
                              onSubmit={handleClauseSubmit}
                            />
                          ) : null}

                        </Col>
                      ) : (
                        <Col span={4}>
                          <Form.Item style={{ borderRadius: 6 }}
                            label="Agreement"
                            name="agreement_file"
                            valuePropName="fileList"
                            getValueFromEvent={(e) => e.fileList}
                          >
                            <div className="w-full">

                              <SingleFileUpload title='Select File' onChnageFile={onChnageFile} accept='.doc,.docx' />

                            </div>

                          </Form.Item>
                        </Col>
                      )}
                      <Modal
                        title=""
                        open={copyConfirmation}
                        onOk={() => {
                          getAutofillDoc(false);
                          handleSubmit();

                        }}
                        onCancel={() => { setCopyConfirmation(false); handleSubmit(); }}
                        okText={isLoading ? "Uploading.." : "Yes"}
                        cancelText="No"
                        okButtonProps={{ disabled: isLoading }}
                      >
                        You have selected a document as agreement file. Press ‘Yes’ if
                        you intend to proceed with the autofill.
                      </Modal>

                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Products / Services" key="2">
                  <Row gutter={16}>
                    <Col span={!!showEditor ? 9 : 24} xs={24} sm={24} md={12} lg={12}>
                      <Form.Item style={{ borderRadius: 6 }} label="Product / Service Name" name="product_list">
                        <CreatableSelect
                          isMulti
                          options={productOptions}
                          required
                          styles={reactSelectTheme}
                          onChange={handleProductChange}
                        />
                      </Form.Item>
                    </Col>
                    {selectedProducts && selectedProducts.length > 0 ? ( // Render the Table only when there are selected products
                      <Table
                        dataSource={data}
                        columns={columns}
                        pagination={false}
                        size="small"
                        bordered
                        className="product-table [&_.ant-table-cell]:whitespace-nowrap [&_.ant-table-cell]:overflow-hidden [&_.ant-table-cell]:text-clip [&_.ant-table-cell]:text-[10px] [&_.ant-table-cell]:max-w-[1px]"
                        scroll={{ x: "1200" }}
                      />
                    ) : (
                      ""
                    )}
                  </Row>
                </TabPane>
                <TabPane tab="Custom Field" key="3">
                  <Row >
                    <Col span={24}>
                      {customFields.map((field, index) => (
                        <Row key={index} gutter={16} align="top" style={{ marginBottom: 12 }}>
                          <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item style={{ borderRadius: 6 }} label={`Particular ${index + 1}`}>
                              <Input
                                value={field.field}
                                onChange={(e) =>
                                  handleCustomFieldChange(index, e.target.value, field.value)
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={12} md={8} lg={8}>
                            <Form.Item style={{ borderRadius: 6 }} label={`Details ${index + 1}`}>
                              <Tooltip placement="right" title={field.value}>
                                <TextArea
                                  autoSize={{ minRows: 1 }}
                                  value={field.value}
                                  onChange={(e) =>
                                    handleCustomFieldChange(index, field.field, e.target.value)
                                  }
                                />
                              </Tooltip>
                            </Form.Item>
                          </Col>

                          <Col xs={24} sm={24} md={8} lg={8}>
                            <Form.Item style={{ borderRadius: 6 }} label=" ">
                              <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleRemoveCustomField(index)}
                              >
                                Remove
                              </Button>
                            </Form.Item>
                          </Col>
                        </Row>
                      ))}
                      <div className="flex w-full justify-end items-center">

                        <Button
                          size="large"
                          onClick={handleAddCustomField}
                          className="mb-4"
                          icon={<PlusCircleOutlined />}
                        >
                          Add Custom Field
                        </Button>
                      </div>
                    </Col>

                  </Row>
                </TabPane>
                <TabPane tab="Receiver's Email" key="4">
                  <Row gutter={16}>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <h3 className="mb-7 bg-slate-100 py-2 pl-6 dark:bg-[#17153B]">
                        Receiver's Emails
                      </h3>
                      <Form.Item style={{ borderRadius: 6 }}
                        label=""
                        name="receivers_email"
                      >
                        <Select
                          options={companyUsers
                            .sort((a, b) => a.label.localeCompare(b.label))
                            .map(user => ({
                              value: user.value,
                              label: `${user.label} (${user.role})`,
                            }))}
                          isMulti
                          required
                          closeMenuOnSelect={false}
                          onChange={handleReceiversEmailChange}
                          styles={reactSelectTheme}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </Col>
            {agreemnt_file && showEditor && (
              <Col span={15} style={{ marginTop: '-55px', overflow: 'auto' }} className="h-full border-l pl-1 pt-4">
                <EditDocComponent
                  key={agreemnt_file}
                  fileUrl={agreemnt_file}
                  userName={select.name}
                  hasBeenShown={hasBeenShown}
                  onClose={handleDocSave}
                  isEditable={true}
                  setShowEditor={setShowEditor}
                />
              </Col>
            )}
          </Row>
        </Form>
      </div>
      <div
        style={{
          bottom: 0,
          left: 0,
          display: "flex",
          justifyContent: "flex-start",
          height: "27vh",
          paddingTop: "30px",
        }}
      >
        {activeTab !== "1" && (
          <ButtonComp
            text="Previous"
            bgColor="#4E36A3"
            textColor="white"
            onClick={handlePrevious}
            margin="2rem"
          />
        )}
        {activeTab !== "4" ? (
          <div>
            <ButtonComp
              text="Save"

              textColor="#4E36A3"
              bgColor="white"
              onClick={() => { handleSubmit() }}
              margin="2rem"
            />
            <ButtonComp
              text="Next"
              bgColor="#4E36A3"
              textColor="white"
              onClick={() => { handleNext() }}
              margin="2rem"
            />


          </div>
        ) : (
          <ButtonComp
            text={isLoading ? "Saving.." : "Save as Draft"}
            bgColor="#4E36A3"
            textColor="white"
            onClick={() => {
              if (agreement_id) {
                handleContractUpdate()
                return;
              } else {
                handleSubmit()
              }
              // }
            }}
            isDisabled={isLoading ? true : false}
          />
        )}
      </div>
    </div>
  );
};

export default InitiateRequest;
